import React from 'react';
import { Link } from 'react-router-dom';
import { getOrderSummaryRoute } from '../../futureOrderUtils';

interface Props {
  orderId: string;
  orderUuid?: string;
  futureOrderType?: 'BackToBack' | 'Indexed';
  maxLength?: number;
}

export const FutureOrderIdLink: React.FC<Props> = ({ futureOrderType, orderId, orderUuid, maxLength = 20 }) => {
  const truncatedOrderId = orderId.length > maxLength ? `${orderId.slice(0, maxLength)}...` : orderId;

  return futureOrderType && orderUuid ? (
    <Link
      to={`/add-future-order/${orderUuid}/${getOrderSummaryRoute(futureOrderType)}`}
      className="text-blue-600 hover:text-blue-800 "
    >
      {truncatedOrderId}
    </Link>
  ) : (
    <span className=" ">{orderId}</span>
  );
};
